import { Directive, ElementRef, HostListener, Input, OnDestroy, Renderer2 } from "@angular/core";
import "./tooltip.scss";
import { ITooltipPosition, TooltipService } from "./tooltip.service";

@Directive({
    selector: "[tooltip]"
})
export class TooltipDirective implements OnDestroy {

    // Bindings

    @Input('tooltip') title: string;
    @Input('tooltip-direction') direction: string = "top";
    @Input('hide-tooltip') hideTooltip = false;
    @Input() titleClass: string;

    // Internals

    delay = 10;

    private showAnimationFrame: number | null = null;
    private hideAnimationFrame: number | null = null;

    constructor(private elementRef: ElementRef, private renderer: Renderer2, private tooltipService: TooltipService) {
    }

    @HostListener('mouseenter') onMouseEnter() {
        if (this.hideTooltip) {
            return;
        }

        // Cancel any pending hide animation
        if (this.hideAnimationFrame) {
            cancelAnimationFrame(this.hideAnimationFrame);
            this.hideAnimationFrame = null;
        }

        // Cancel any pending show animation before scheduling a new one
        if (this.showAnimationFrame) {
            cancelAnimationFrame(this.showAnimationFrame);
        }

        // Use RAF to schedule tooltip creation
        this.showAnimationFrame = requestAnimationFrame(() => {
            this.show();
            this.showAnimationFrame = null;
        });
    }

    @HostListener('mouseleave') onMouseLeave() {
        // If the show animation is still pending, cancel it
        if (this.showAnimationFrame) {
            cancelAnimationFrame(this.showAnimationFrame);
            this.showAnimationFrame = null;
        }

        // Use RAF to schedule tooltip removal
        this.hideAnimationFrame = requestAnimationFrame(() => {
            this.removeTooltip();
            this.hideAnimationFrame = null;
        });
    }

    @HostListener('click') onClick() {
        this.removeTooltip();
    }

    ngOnDestroy() {
        this.removeTooltip();
    }

    show() {
        if (!this.title) {
            return;
        }

        this.tooltipService.show(this.title, this.getPosition());
    }

    removeTooltip() {
        this.tooltipService.hide();
    }

    // ---

    private getPosition(): ITooltipPosition {
        //this.setDirection();

        //var tooltipBounding = this.tooltip.getBoundingClientRect();
        var elBounding = this.elementRef.nativeElement.getBoundingClientRect();
        var scrollLeft = window.scrollX || document.documentElement.scrollLeft;
        var scrollTop = window.scrollY || document.documentElement.scrollTop;
        var arrow_padding = 12;
        var pos: ITooltipPosition = { left: 0, top: 0 };
        var newDirection = null;

        // calculate the left position
        if (this.stringStartsWith(this.direction, 'left')) {
            pos.left = elBounding.left/* - tooltipBounding.width*/ - (arrow_padding / 2) + scrollLeft;
        }
        else if (this.stringStartsWith(this.direction, 'right')) {
            pos.left = elBounding.left + elBounding.width + (arrow_padding / 2) + scrollLeft;
        }
        else if (this.stringContains(this.direction, 'left')) {
            pos.left = elBounding.left /*- tooltipBounding.width */ + arrow_padding + scrollLeft;
        }
        else if (this.stringContains(this.direction, 'right')) {
            pos.left = elBounding.left + elBounding.width - arrow_padding + scrollLeft;
        }
        else {
            pos.left = elBounding.left + (elBounding.width / 2) /*- (tooltipBounding.width / 2)*/ + scrollLeft;
        }

        // calculate the top position
        if (this.stringStartsWith(this.direction, 'top')) {
            pos.top = elBounding.top /*- tooltipBounding.height*/ - (arrow_padding / 2) + scrollTop;
        }
        else if (this.stringStartsWith(this.direction, 'bottom')) {
            pos.top = elBounding.top + elBounding.height + (arrow_padding / 2) + scrollTop;
        }
        else if (this.stringContains(this.direction, 'top')) {
            pos.top = elBounding.top - /*tooltipBounding.height +*/ arrow_padding + scrollTop;
        }
        else if (this.stringContains(this.direction, 'bottom')) {
            pos.top = elBounding.top + elBounding.height - arrow_padding + scrollTop;
        }
        else {
            pos.top = elBounding.top + (elBounding.height / 2) /*- (tooltipBounding.height / 2)*/ + scrollTop;
        }

        // Todo?
        // check if the tooltip is outside the bounds of the window
        //if (this.fixedPosition) {
        //    if (pos.left < scrollLeft) {
        //        newDirection = this.direction.replace('left', 'right');
        //    }
        //    else if ((pos.left + tooltipBounding.width) > (window.innerWidth + scrollLeft)) {
        //        newDirection = this.direction.replace('right', 'left');
        //    }

        //    if (pos.top < scrollTop) {
        //        newDirection = this.direction.replace('top', 'bottom');
        //    }
        //    else if ((pos.top + tooltipBounding.height) > (window.innerHeight + scrollTop)) {
        //        newDirection = this.direction.replace('bottom', 'top');
        //    }

        //    if (newDirection) {
        //        //return this.calculatePosition(this.tooltip, newDirection);
        //    }
        //}

        //pos.left += 'px';
        //pos.top += 'px';
        pos.direction = this.direction;

        return pos;
    }

    private stringStartsWith(searchString, findString): boolean {
        if (!searchString) {
            console.warn("stringStartsWith searchString null", searchString, findString);
            return false;
        }

        return searchString.substr(0, findString.length) === findString;
    }

    private stringContains(searchString, findString): boolean {
        return searchString.indexOf(findString) !== -1;
    }
}
